"use strict";
/*
    import objects referenced by hsrcs and make them inline
    resolve references to URLs based on their repository base
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inline = exports.inlineElement = void 0;
const traverse_1 = __importDefault(require("traverse"));
const deepmerge_1 = __importDefault(require("deepmerge"));
const httpClient_1 = __importDefault(require("./httpClient"));
const logger_1 = require("@sundaysky/logger");
const url = require("url");
const log = (0, logger_1.logger)("inliner");
const DEFAULT_RETRY_OPTIONS = {
    limit: 2, // total is +1 since it doesn't count initial run
    baseDelay: 100,
    timeout: httpClient_1.default.DEFAULT_TIMEOUT
};
/**
 * get a single HSRC element which must be inlined
 * @param elemRef
 * @param baseurl
 * @param repositories
 * @param config
 * @param headers
 * @param eventLogger
 * @param skipHsrc
 * @returns {Promise<T>}
 */
const inlineElement = (elemRef, baseurl, repositories, config, headers, eventLogger, skipHsrc) => __awaiter(void 0, void 0, void 0, function* () {
    const absUrl = elemRef.ref.hsrc;
    const gotRetryOptions = Object.assign({}, DEFAULT_RETRY_OPTIONS, config === null || config === void 0 ? void 0 : config.retryOptions);
    try {
        const response = yield httpClient_1.default.getWithRetries(absUrl, headers, gotRetryOptions, log.info.bind(log));
        log.info(`inlining ${elemRef.key} from ${absUrl}`);
        let newelem = response.body ? response.body : {};
        if (typeof newelem === "object") {
            // merge other properties from the input into the results
            newelem = (0, deepmerge_1.default)(newelem, elemRef.ref);
            // remove inlined keys
            if (newelem.hsrc)
                delete newelem.hsrc;
            if (newelem.repository)
                delete newelem.repository;
        }
        elemRef.parent[elemRef.key] = newelem;
        const tree = yield elemRef.parent[elemRef.key];
        return (0, exports.inline)(tree, absUrl, repositories, config, headers, eventLogger, skipHsrc);
    }
    catch (e) {
        let err = e;
        if (config === null || config === void 0 ? void 0 : config.strict) {
            const errorMessage = `Error retrieving ${absUrl}. message: ${e === null || e === void 0 ? void 0 : e.message}`;
            if (!e.absUrl) {
                err = new Error(errorMessage);
                err.absUrl = absUrl;
            }
            log.error(errorMessage);
            throw err;
        }
        else {
            // Ignore error for now. If the inlining was necessary, the call will fail at a later point anyway
            log.info(`Could not retrieve ${absUrl}. message: ${e === null || e === void 0 ? void 0 : e.message}`);
            if (elemRef.ref && elemRef.ref.hsrc) {
                delete elemRef.ref.hsrc; //delete hsrc when could not inline. avoid recursive inline
            }
        }
    }
});
exports.inlineElement = inlineElement;
const isHsrcElement = (elem) => {
    return elem && elem.hasOwnProperty("hsrc") && !!elem.hsrc;
};
const isRelativeUrlElement = (elem) => {
    if (!elem || !(typeof elem === "object")) {
        return false;
    }
    const size = Object.keys(elem).length;
    return elem.hasOwnProperty("repo-url") && elem["repo-url"]
        && (size === 1 || (size === 2 && elem.hasOwnProperty("repository")));
};
/**
 *  HSRC elements need to be asynchronously 'gotten' and added inline
 * @param absRoot
 * @param baseurl
 * @param repositories
 * @param config
 * @param headers
 * @param eventLogger
 * @returns {Promise<any[]>}
 */
const inlineAllHsrcs = (absRoot, baseurl, repositories, config, headers, eventLogger) => {
    let hsrcs = [];
    (0, traverse_1.default)(absRoot).forEach(function (elem) {
        if (isHsrcElement(elem)) {
            hsrcs.push({ ref: elem, parent: this.parent.node, key: this.key });
        }
    });
    if (hsrcs.length > 0)
        log.info("Resolving hsrc references", hsrcs.map(h => h.ref.hsrc));
    // create promises
    let promises = hsrcs.map(hsrc => (0, exports.inlineElement)(hsrc, baseurl, repositories, config, headers, eventLogger, false));
    return Promise.all(promises);
};
const preresolve = (elements, endpoint, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const key = (e) => {
        return `${e.repo}:${e.url}`;
    };
    const toLookupMap = (elements) => {
        return elements.reduce((lookupMap, e) => {
            lookupMap[key(e)] = e;
            return lookupMap;
        }, {});
    };
    // remove duplicates and convert to structure used by resolver
    const deduped = Object.values(toLookupMap(elements));
    const formatted = deduped.map((e) => {
        return Object.assign({
            url: e.url,
            repo: e.repo
        }, e.repoinfo.preresolve.metadata);
    });
    const retryOptions = Object.assign({}, DEFAULT_RETRY_OPTIONS, { limit: 0 }); // no retry
    const response = yield httpClient_1.default.postWithRetries(endpoint, formatted, headers, retryOptions, log.info.bind(log));
    const body = response.body;
    const lookupResponse = toLookupMap(body);
    for (let e of elements) {
        let r = lookupResponse[key(e)];
        if (r) {
            e.parent[e.key] = r.resolved;
        }
    }
});
const urlFromElem = (elem) => {
    var _a;
    return (_a = elem === null || elem === void 0 ? void 0 : elem.hsrc) !== null && _a !== void 0 ? _a : elem["repo-url"];
};
const resolved = (u, base) => {
    // todo - fix deprecated
    return base ? url.resolve(base, u) : u;
};
const repoInfo = (elem, repositories) => {
    var _a, _b;
    if ((elem === null || elem === void 0 ? void 0 : elem.repository) && repositories) {
        const repository = elem.repository;
        const baseurl = repositories[repository];
        const preresolve = ((_b = (_a = repositories.preresolve) === null || _a === void 0 ? void 0 : _a.repositories) === null || _b === void 0 ? void 0 : _b[repository]) &&
            {
                endpoint: repositories.preresolve.endpoint,
                metadata: repositories.preresolve.repositories[repository]
            };
        return { repository, baseurl, preresolve };
    }
    else
        return {};
};
const absolutify = (elem, base, repositories) => {
    var _a;
    const theUrl = urlFromElem(elem);
    const resolvedBaseUrl = (_a = repoInfo(elem, repositories).baseurl) !== null && _a !== void 0 ? _a : base;
    return resolved(theUrl, resolvedBaseUrl);
};
/**
 * find all urls that must be absolutified using  a repository base, and replace them with the absolute url
 * @param tree
 * @param baseurl
 * @param repositories
 * @param config
 * @param headers
 * @param eventLogger
 * @returns {Promise<any>}
 */
const absolutifyAll = (tree, baseurl, repositories, config, headers, eventLogger) => {
    const startStage = (stage, data) => eventLogger === null || eventLogger === void 0 ? void 0 : eventLogger.startStage(stage, data);
    const endStage = (stage, data) => eventLogger === null || eventLogger === void 0 ? void 0 : eventLogger.endStage(stage, data);
    if (typeof tree !== "object") {
        return Promise.resolve(tree);
    }
    let needsPreresolve = [];
    const handleReference = (parent, key, element) => {
        const repoinfo = repoInfo(element, repositories);
        const repo = repoinfo.repository;
        const url = urlFromElem(element);
        if (repoinfo.preresolve) {
            // collect to a list
            needsPreresolve.push({ parent, key, url, repo, repoinfo });
        }
        else {
            // no preresolving, just absolutify
            parent[key] = absolutify(element, baseurl, repositories);
        }
        // remove repository so that we dont try to absolutify this recursively
        delete element.repository;
    };
    (0, traverse_1.default)(tree).forEach(function (elem) {
        if (isHsrcElement(elem)) {
            this.parent.node[this.key] = elem;
            handleReference(this.parent.node[this.key], "hsrc", elem);
        }
        else if (isRelativeUrlElement(elem)) {
            handleReference(this.parent.node, this.key, elem);
        }
    });
    if (needsPreresolve.length > 0 && repositories.preresolve.endpoint) {
        startStage("preresolve");
        return preresolve(needsPreresolve, repositories.preresolve.endpoint, headers)
            .then(() => {
            endStage("preresolve");
            return tree;
        });
    }
    // else...
    return Promise.resolve(tree);
};
/**
 * This function recursively processes a tree,
 * A) It inlines any elements defined by an HSRC property, and then recursively applies itself to the
 * retrieved result
 * B) It absolutifies any urls with the REPO-URL property

 *  A 'repository' property can be added to any HSRC or REPO-URL object, when present, the base-url for that
 *  repository is used to resolve the relative url.
 *
 * @param tree - an arbitrary object, usually the result of parsing json
 * @param baseurl - a base url for resolving relative urls when a repository is not specified
 * @param repositories - a map of base urls. Maps repository-name->base-url
 * @param config - config
 * @param headers - headers
 * @param eventLogger - event logger
 * @param skipHsrc - skip HSRC flag
 * @returns a promise which resolves to the inlined tree. Note that the replacement is done in-place. The original tree
 * will be modified
 */
const inline = (tree, baseurl, repositories, config, headers, eventLogger, skipHsrc) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof tree !== "object") {
        return Promise.resolve(tree);
    }
    // wrap the top level to allow inlining at the root
    let theRoot = { root: tree };
    // first absolutify all
    const absRoot = yield absolutifyAll(theRoot, baseurl, repositories, config, headers, eventLogger);
    // then, deal with hsrcs which must be fetched asynchronously
    if (!skipHsrc) {
        yield inlineAllHsrcs(absRoot, baseurl, repositories, config, headers, eventLogger);
    }
    return theRoot.root;
});
exports.inline = inline;
//# sourceMappingURL=inliner.js.map